const skillData = [
    [
        'FrontEnd',
        [['F', 1], ['R', 2], ['O', 3], ['N', 4], ['T', 5], ['E', 6], ['N', 7], ['D', 8]],
        ['NextJS', 'TailwindCSS', 'TypeScript', 'MaterialUI', 'Bootstrap', 'Flutter', 'Dart', 'DaisyUI',],
    ],
    [
        'BackEnd',
        [['B', 1], ['A', 2], ['C', 3], ['K', 4], ['E', 5], ['N', 6], ['D', 7]],
        ['NodeJS', 'ExpressJS', 'NextAuth', 'BCryptJS', 'MongoDB', 'MySQL', 'JWT'],
    ],
    [
        'Others',
        [['O', 1], ['T', 2], ['H', 3], ['E', 4], ['R', 5], ['S', 6]],
        ['C++', 'Python', 'GitHub', 'Latex', 'ROS', 'Premiere Pro', 'FL Studio', 'Inventor'],
    ],
];

export default skillData;
